<template>
    <div>
        <payment-methods v-if="!marketConfig.enableVuePayments" msg="Payment Methods"/>
        <payment-section v-if="marketConfig.enableVuePayments" />
    </div>
</template>

<script>
// @ is an alias to /src
import PaymentMethods from '@/components/PaymentMethods.vue';
import PaymentSection from '@/components/PaymentSection.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'paymentView',
    components: {
        PaymentMethods,
        PaymentSection
    },
    computed: {
        ...mapGetters({
            marketConfig: 'marketConfig'
        })
    }
};
</script>
